import Highcharts from "highcharts";
import BSelect from "../Modules/BSelect";

export default class JPMeasurementChart
{
	constructor(el)
	{
		this.el = el;
		this.select = el.querySelector("[data-jp-measurement-chart-kind]");
		this.plot = el.querySelector("[data-jp-measurement-chart-plot]");
		this.latest = el.querySelector("[data-jp-measurement-chart-latest]");
		this.empty = el.querySelector("[data-jp-measurement-chart-empty]");
		this.payload = this.parsePayload(el.dataset.jpMeasurementChart);
		this.chart = null;

		if (this.select) {
			BSelect.initializeElement(this.select);
			this.select.addEventListener("change", () => this.renderSelected());
		}
	}

	static selector = () => `[data-jp-measurement-chart]`;

	static initialize(root = document)
	{
		root.querySelectorAll(this.selector()).forEach((el) => {
			new this(el);
		});
	}

	parsePayload(raw)
	{
		try {
			return JSON.parse(raw || "{}");
		} catch (error) {
			console.error(error);
			return {};
		}
	}

	renderSelected()
	{
		const code = this.select?.value;
		const entry = code ? this.payload[code] : null;
		if (!entry) {
			return;
		}

		if (this.latest) {
			this.latest.textContent = entry.latest || "";
		}

		const canRender = (entry.pointCount || 0) >= 2 && entry.options;
		if (this.empty) {
			this.empty.hidden = canRender;
		}

		if (!this.plot) {
			return;
		}

		if (!canRender) {
			if (this.chart) {
				this.chart.destroy();
				this.chart = null;
			}
			this.plot.hidden = true;
			this.plot.removeAttribute("data-chart-options");
			return;
		}

		this.plot.hidden = false;
		this.plot.classList.add("chart");
		this.plot.dataset.chartOptions = JSON.stringify(entry.options);

		if (this.chart) {
			this.chart.destroy();
			this.chart = null;
		}

		try {
			this.chart = Highcharts.chart(this.plot, entry.options);
		} catch (error) {
			console.error(error);
		}
	}
}
